

// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});
import {sendEmail, sendEmailWithRecipient} from 'backend/email';

$w.onReady(function () {
  $w("#dataset2").onAfterSave(sendFormData);
});

function sendFormData() {
  const subject = `יצירת קשר`;
  const body = `Type Here: ${$w("#input6").value}
    \rLabelHere: ${$w("#input1").value}
    \rLabelHere: ${$w("#input5").value}
    \rLabelHere: ${$w("#input7").value}`;
  const recipient = $w("#input1").value;
 
  sendEmailWithRecipient(subject, body, recipient)
    .then(response => console.log(response)); 
    
  sendEmail(subject, body)
    .then(response => console.log(response));
}